module.exports = {
      id: "logo-tiny-usage",
      viewBox: "0 0 642 180",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#logo-tiny",
      toString: function () {
        return this.url;
      }
    }